// Sessao da api-btk (access + refresh token) numa chave do localStorage.
// Fica no localStorage, e nao em memoria ou sessionStorage, porque a captura
// da proposta abre outra aba (/Loading): todas as abas precisam da mesma
// sessao, ja que o refresh token vale uma vez so e o reuso derruba a sessao.
const CHAVE = "erp-btk:sessao";

// localStorage bloqueado (aba anonima, politica do navegador): a sessao fica
// so em memoria e vale ate fechar a aba.
let semStorage = false;
let emMemoria = null;
const ouvintes = new Set();

function lerBruto() {
  if (!semStorage) {
    try {
      return JSON.parse(localStorage.getItem(CHAVE));
    } catch {
      // bloqueado ou corrompido: cai na copia em memoria
    }
  }
  return emMemoria;
}

function gravarBruto(sessao) {
  emMemoria = sessao;
  try {
    if (sessao) {
      localStorage.setItem(CHAVE, JSON.stringify(sessao));
    } else {
      localStorage.removeItem(CHAVE);
    }
    semStorage = false;
  } catch {
    semStorage = true;
  }
}

function notificar(motivo) {
  ouvintes.forEach((ouvinte) => ouvinte({ motivo }));
}

const valida = (sessao) =>
  Boolean(sessao) &&
  typeof sessao.accessToken === "string" &&
  typeof sessao.refreshToken === "string" &&
  Number.isFinite(sessao.accessTokenExpiraEm) &&
  Number.isFinite(sessao.refreshTokenExpiraEm);

/**
 * Monta a sessao a partir da resposta de /Auth/Login ou /Auth/Refresh.
 * A expiracao do access token e contada no relogio do navegador (expiresIn),
 * sem depender do relogio do servidor.
 * @returns a sessao, ou null se a resposta nao tiver o formato esperado.
 */
export function criarSessao(
  { accessToken, expiresIn, refreshToken, refreshTokenExpiresAt } = {},
  usuario,
  agora = Date.now()
) {
  const sessao = {
    accessToken,
    accessTokenExpiraEm: agora + Number(expiresIn) * 1000,
    refreshToken,
    refreshTokenExpiraEm: Date.parse(refreshTokenExpiresAt),
    usuario,
  };
  return valida(sessao) ? sessao : null;
}

export function lerSessao() {
  const sessao = lerBruto();
  if (!valida(sessao)) return null;

  // Passou do prazo fixo da sessao (15 dias do login): nao ha como renovar.
  if (sessao.refreshTokenExpiraEm <= Date.now()) {
    limparSessao("expirada");
    return null;
  }

  return sessao;
}

export function salvarSessao(sessao) {
  gravarBruto(sessao);
  notificar(null);
}

/** @param {"expirada" | null} motivo mostrado na tela de login. */
export function limparSessao(motivo = null) {
  gravarBruto(null);
  notificar(motivo);
}

// O evento storage so dispara nas outras abas: e assim que um logout (ou uma
// renovacao) feito em uma aba chega nas demais.
function aoMudarEmOutraAba(evento) {
  if (evento.key === CHAVE || evento.key === null) notificar(null);
}

/** Avisa quando a sessao muda nesta aba ou em outra. Devolve o cancelamento. */
export function assinarSessao(ouvinte) {
  if (ouvintes.size === 0) window.addEventListener("storage", aoMudarEmOutraAba);
  ouvintes.add(ouvinte);

  return () => {
    ouvintes.delete(ouvinte);
    if (ouvintes.size === 0) window.removeEventListener("storage", aoMudarEmOutraAba);
  };
}
